import React from 'react';
import styled from 'styled-components';

const ShopSection = styled.section`
  padding: 80px 40px;
  background: ${props => props.theme.colors.background};
`;

const Container = styled.div`
  max-width: ${props => props.theme.spacing.container};
  margin: 0 auto;
`;

const ShopContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 600px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
  
  @media (max-width: 768px) {
    height: 450px;
  }
`;

const ShopImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const ShopInfo = styled.div`
  padding: 20px;
`;

const ShopTitle = styled.h2`
  font-size: 42px;
  margin-bottom: 25px;
  color: ${props => props.theme.colors.primary};
  font-weight: 300;
  letter-spacing: 1px;
  line-height: 1.2;
  
  span {
    color: ${props => props.theme.colors.secondary};
    font-weight: 400;
    display: block;
    font-size: 24px;
    margin-top: 10px;
  }
  
  @media (max-width: 768px) {
    font-size: 32px;
    
    span {
      font-size: 20px;
    }
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  margin: 30px 0;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const InfoCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  }
`;

const InfoIcon = styled.div`
  font-size: 24px;
  margin-bottom: 10px;
`;

const InfoLabel = styled.h4`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: ${props => props.theme.colors.secondary};
  margin-bottom: 8px;
`;

const InfoText = styled.p`
  font-size: 16px;
  color: #555;
  line-height: 1.6;
  margin: 0;
  
  i {
    color: ${props => props.theme.colors.secondary};
    margin-right: 8px;
    font-style: normal;
  }
`;

const HoursList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const HoursRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  padding: 4px 0;
  border-bottom: 1px dashed #eee;
  
  .day {
    color: ${props => props.theme.colors.primary};
    font-weight: 500;
  }
  
  .time {
    color: #666;
  }
`;

const Badge = styled.span`
  background: ${props => props.theme.colors.secondary};
  color: white;
  font-size: 12px;
  padding: 6px 15px;
  border-radius: 30px;
  letter-spacing: 1.5px;
  display: inline-block;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-weight: 500;
  box-shadow: 0 4px 10px rgba(196, 164, 132, 0.3);
`;

const AppointmentBadge = styled.div`
  background: #f8f9fa;
  border-left: 3px solid ${props => props.theme.colors.secondary};
  padding: 15px 20px;
  margin-top: 25px;
  border-radius: 0 8px 8px 0;
  
  p {
    margin: 5px 0;
    color: #555;
    font-size: 14px;
    
    strong {
      color: ${props => props.theme.colors.primary};
      font-weight: 600;
    }
  }
`;

const ShopImageComponent = () => {
  return (
    <ShopSection>
      <Container>
        <ShopContent>
          <ImageWrapper>
            <ShopImage 
              src="https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" 
              alt="Cey-Valora Gems Atlanta Showroom"
            />
          </ImageWrapper>
          <ShopInfo>
            <Badge>✦ SINCE 2024</Badge>
            <ShopTitle>
              Cey-Valora
              <span>Atlanta Showroom</span>
            </ShopTitle>
            
            <InfoGrid>
              <InfoCard>
                <InfoIcon>📍</InfoIcon>
                <InfoLabel>ADDRESS</InfoLabel>
                <InfoText>Atlanta, Georgia</InfoText>
              </InfoCard>
              
              <InfoCard>
                <InfoIcon>📞</InfoIcon>
                <InfoLabel>CONTACT</InfoLabel>
                <InfoText>+1 (470) 670-7456<br />info@ceylora.com<br />Private Appointments</InfoText>
              </InfoCard>
              
              <InfoCard>
                <InfoIcon>🕐</InfoIcon>
                <InfoLabel>HOURS</InfoLabel>
                <HoursList>
                  <HoursRow>
                    <span className="day">Mon - Sun</span>
                    <span className="time">8am - 5pm</span>
                  </HoursRow>
                </HoursList>
              </InfoCard>
              
              <InfoCard>
                <InfoIcon>⚲</InfoIcon>
                <InfoLabel>SERVICES</InfoLabel>
                <InfoText>Private Consultations<br />Gemstone Viewing<br />Custom Designs</InfoText>
              </InfoCard>
            </InfoGrid>
            
            <AppointmentBadge>
              <p><strong>✦ Private Appointments Available</strong></p>
              <p>Schedule a confidential viewing of our exclusive collection</p>
              <p><i>📅</i> Please call to reserve your preferred time</p>
            </AppointmentBadge>
          </ShopInfo>
        </ShopContent>
      </Container>
    </ShopSection>
  );
};

export default ShopImageComponent;
